import { Icon } from '../ui/icons';
import { useTheme } from './ThemeProvider';

/**
 * Cycles light → dark → system. Label always names the *next* click so the
 * control reads as an action, not a status badge.
 */
export function ThemeToggle({ className = '' }: { className?: string }) {
  const { mode, resolved, cycle } = useTheme();

  const label =
    mode === 'light'
      ? 'Тёмная тема'
      : mode === 'dark'
        ? 'Как в системе'
        : resolved === 'dark'
          ? 'Светлая тема'
          : 'Тёмная тема';

  const tip =
    mode === 'system'
      ? `Тема: как в системе (${resolved === 'dark' ? 'тёмная' : 'светлая'})`
      : mode === 'dark'
        ? 'Тема: тёмная'
        : 'Тема: светлая';

  return (
    <button
      type="button"
      className={`icon-btn ${className}`.trim()}
      aria-label={label}
      data-tip={tip}
      onClick={cycle}
    >
      <Icon name={resolved === 'dark' ? 'sun' : 'moon'} size={16} />
    </button>
  );
}
